import React from 'react';
import { Document, Page, View, Text, StyleSheet } from '@react-pdf/renderer';

/*
 * Hoja de Estado de cuenta en PDF real (react-pdf). Recibe `data` ya formateado
 * desde CarteraEstadosCuenta (strings listos), incluida la VENTANA del calendario
 * (cuota actual + N arriba / N abajo) — no la tabla completa.
 */
const NAVY = '#0C2036';
const BLUE = '#21588C';
const CYAN = '#32B8DF';
const INK = '#0F172A';
const INK2 = '#475569';
const INK3 = '#64748B';
const INK4 = '#94A3B8';
const LINE = '#EEF2F5';

const s = StyleSheet.create({
  page: { paddingTop: 26, paddingBottom: 30, paddingHorizontal: 34, fontSize: 9, color: INK, fontFamily: 'Helvetica' },
  tri: { height: 3, flexDirection: 'row' },
  headRow: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start', paddingBottom: 12 },
  brand: { fontSize: 18, fontFamily: 'Helvetica-Bold', color: NAVY, letterSpacing: -0.5 },
  brandSub: { fontSize: 7, color: INK4, marginTop: 3 },
  badge: { fontSize: 7.5, fontFamily: 'Helvetica-Bold', color: BLUE, backgroundColor: '#E8EFF6', paddingVertical: 3, paddingHorizontal: 7, borderRadius: 4 },
  metaLine: { fontSize: 8, color: INK3, marginTop: 5, textAlign: 'right' },
  hr: { borderBottomWidth: 1, borderBottomColor: LINE, marginVertical: 10 },
  sectionLbl: { fontSize: 7.5, color: INK4, fontFamily: 'Helvetica-Bold', letterSpacing: 0.5, textTransform: 'uppercase', marginBottom: 6 },
  twoCol: { flexDirection: 'row', justifyContent: 'space-between' },
  name: { fontSize: 12, fontFamily: 'Helvetica-Bold', color: INK },
  sub: { fontSize: 8.5, color: INK3, marginTop: 3, lineHeight: 1.5 },
  clave: { fontSize: 12, fontFamily: 'Helvetica-Bold', color: BLUE, textAlign: 'right' },
  prodName: { fontSize: 8.5, color: INK3, marginTop: 2, textAlign: 'right' },
  chip: { fontSize: 8, fontFamily: 'Helvetica-Bold', paddingVertical: 2, paddingHorizontal: 8, borderRadius: 5, marginTop: 4, alignSelf: 'flex-end' },
  vehRow: { flexDirection: 'row', flexWrap: 'wrap' },
  vehItem: { marginRight: 26, marginBottom: 4 },
  vehLbl: { fontSize: 7, color: INK4 },
  vehVal: { fontSize: 9, fontFamily: 'Helvetica-Bold', color: INK, marginTop: 1 },
  finRow: { flexDirection: 'row', justifyContent: 'space-between' },
  finCard: { width: '32%', backgroundColor: '#F5F9FC', borderWidth: 1, borderColor: '#EAF0F5', borderRadius: 8, padding: 9 },
  finLbl: { fontSize: 7, color: INK4, textTransform: 'uppercase', letterSpacing: 0.4 },
  finVal: { fontSize: 12.5, fontFamily: 'Helvetica-Bold', color: INK, marginTop: 5 },
  finSub: { fontSize: 7.5, color: INK3, marginTop: 2 },
  vencBox: { backgroundColor: '#FBE7E7', borderWidth: 1, borderColor: '#F6CFCF', borderRadius: 8, padding: 10, flexDirection: 'row', justifyContent: 'space-between', marginTop: 4 },
  vencLbl: { fontSize: 7, color: '#B91C1C', fontFamily: 'Helvetica-Bold', textTransform: 'uppercase' },
  vencVal: { fontSize: 12, fontFamily: 'Helvetica-Bold', color: '#DC2626', marginTop: 3 },
  tiles: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 8 },
  tile: { width: '32%', borderRadius: 8, padding: 8 },
  tileVal: { fontSize: 13, fontFamily: 'Helvetica-Bold' },
  tileLbl: { fontSize: 7, fontFamily: 'Helvetica-Bold', textTransform: 'uppercase', letterSpacing: 0.3, marginTop: 1 },
  parcHead: { flexDirection: 'row', backgroundColor: '#F5F8FB', paddingVertical: 5, paddingHorizontal: 8, borderRadius: 5 },
  parcRow: { flexDirection: 'row', paddingVertical: 5, paddingHorizontal: 8, borderBottomWidth: 1, borderBottomColor: '#F4F7F9' },
  parcRowCur: { flexDirection: 'row', paddingVertical: 6, paddingHorizontal: 8, borderWidth: 1, borderColor: CYAN, borderRadius: 6, backgroundColor: '#F2FBFE', marginVertical: 2 },
  cN: { width: '10%', fontSize: 8, color: INK4, fontFamily: 'Helvetica-Bold' },
  cMes: { width: '42%', fontSize: 8.5, color: INK2, textTransform: 'capitalize' },
  cNota: { fontSize: 7, color: '#B4531A', marginTop: 1 },
  cSub: { fontSize: 7, color: INK4, marginTop: 1 },
  cMonto: { width: '26%', fontSize: 8.5, fontFamily: 'Helvetica-Bold', textAlign: 'right' },
  cEst: { width: '22%', fontSize: 8, textAlign: 'right', fontFamily: 'Helvetica-Bold' },
  hCell: { fontSize: 7, color: INK3, fontFamily: 'Helvetica-Bold', textTransform: 'uppercase' },
  liquid: { backgroundColor: NAVY, borderRadius: 10, padding: 13, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 14 },
  liquidLbl: { fontSize: 7.5, color: '#9FC7DE', fontFamily: 'Helvetica-Bold', textTransform: 'uppercase' },
  liquidDesc: { fontSize: 8, color: '#CFE3EF', marginTop: 3 },
  liquidVal: { fontSize: 18, fontFamily: 'Helvetica-Bold', color: '#FFFFFF' },
  footer: { fontSize: 7.5, color: INK4, lineHeight: 1.5, marginTop: 14, paddingTop: 10, borderTopWidth: 1, borderTopColor: LINE },
});

const Tri = () => (
  <View style={s.tri}>
    <View style={{ flex: 1, backgroundColor: '#204B7B' }} />
    <View style={{ flex: 1, backgroundColor: CYAN }} />
    <View style={{ flex: 1, backgroundColor: '#00BA6E' }} />
  </View>
);

export const EstadoCuentaPDF = ({ data }) => {
  const d = data || {};
  return (
    <Document>
      <Page size="A4" style={s.page}>
        {/* Encabezado */}
        <View style={s.headRow}>
          <View>
            <Text style={s.brand}>peicar</Text>
            <Text style={s.brandSub}>Peicar Arrendamiento S.A.P.I. de C.V.  ·  La llave a tu movilidad</Text>
          </View>
          <View style={{ alignItems: 'flex-end' }}>
            <Text style={s.badge}>ESTADO DE CUENTA</Text>
            <Text style={s.metaLine}>{d.fecha}</Text>
            <Text style={s.metaLine}>Folio {d.folio}</Text>
          </View>
        </View>
        <Tri />
        <View style={{ height: 12 }} />

        {/* Cliente / contrato */}
        <View style={s.twoCol}>
          <View style={{ flex: 1, paddingRight: 16 }}>
            <Text style={s.sectionLbl}>Cliente</Text>
            <Text style={s.name}>{d.cliente?.nombre}</Text>
            <Text style={s.sub}>
              {d.cliente?.linea1}
              {d.cliente?.linea1 ? '\n' : ''}{d.cliente?.linea2}
            </Text>
          </View>
          <View>
            <Text style={[s.sectionLbl, { textAlign: 'right' }]}>Contrato</Text>
            <Text style={s.clave}>{d.contrato?.clave}</Text>
            <Text style={s.prodName}>{d.contrato?.prodName}</Text>
            <Text style={[s.chip, { color: d.contrato?.etapaColor, backgroundColor: d.contrato?.etapaBg }]}>{d.contrato?.etapaLabel}</Text>
          </View>
        </View>

        {/* Vehículo */}
        {d.vehiculo && (
          <>
            <View style={s.hr} />
            <Text style={s.sectionLbl}>Bien arrendado</Text>
            <View style={s.vehRow}>
              {d.vehiculo.nombre ? <View style={s.vehItem}><Text style={s.vehLbl}>Vehículo</Text><Text style={s.vehVal}>{d.vehiculo.nombre}</Text></View> : null}
              {d.vehiculo.anio ? <View style={s.vehItem}><Text style={s.vehLbl}>Año</Text><Text style={s.vehVal}>{d.vehiculo.anio}</Text></View> : null}
              {d.vehiculo.placas ? <View style={s.vehItem}><Text style={s.vehLbl}>Placas</Text><Text style={s.vehVal}>{d.vehiculo.placas}</Text></View> : null}
              {d.vehiculo.vin ? <View style={s.vehItem}><Text style={s.vehLbl}>VIN</Text><Text style={s.vehVal}>{d.vehiculo.vin}</Text></View> : null}
            </View>
          </>
        )}

        {/* Detalle financiero */}
        <View style={s.hr} />
        <Text style={s.sectionLbl}>Detalle financiero</Text>
        <View style={s.finRow}>
          {(d.finCards || []).map((f, i) => (
            <View key={i} style={s.finCard}>
              <Text style={s.finLbl}>{f.label}</Text>
              <Text style={s.finVal}>{f.value}</Text>
              <Text style={s.finSub}>{f.sub}</Text>
            </View>
          ))}
        </View>

        {/* Saldo vencido */}
        {d.vencido && (
          <View style={s.vencBox}>
            <View><Text style={s.vencLbl}>Saldo vencido</Text><Text style={s.vencVal}>{d.vencido.saldo}</Text></View>
            {d.vencido.mora ? <View><Text style={s.vencLbl}>Moratorios</Text><Text style={s.vencVal}>{d.vencido.mora}</Text></View> : null}
            <View style={{ alignItems: 'flex-end' }}><Text style={s.vencLbl}>Total a regularizar</Text><Text style={[s.vencVal, { fontSize: 14 }]}>{d.vencido.total}</Text></View>
          </View>
        )}

        {/* Calendario (ventana) */}
        <View style={s.hr} />
        <Text style={s.sectionLbl}>{d.calendarTitle}</Text>
        <View style={s.tiles}>
          <View style={[s.tile, { backgroundColor: '#E5F8EF' }]}><Text style={[s.tileVal, { color: '#00BA6E' }]}>{d.tiles?.pagadas}</Text><Text style={[s.tileLbl, { color: '#00905A' }]}>Pagadas</Text></View>
          <View style={[s.tile, { backgroundColor: '#EAF6FB' }]}><Text style={[s.tileVal, { color: '#2BA7CE' }]}>{d.tiles?.actual}</Text><Text style={[s.tileLbl, { color: '#0E7FA6' }]}>Cuota actual</Text></View>
          <View style={[s.tile, { backgroundColor: '#F1F5F9' }]}><Text style={[s.tileVal, { color: INK2 }]}>{d.tiles?.porPagar}</Text><Text style={[s.tileLbl, { color: INK3 }]}>Por pagar</Text></View>
        </View>
        {d.windowNote ? <Text style={{ fontSize: 7.5, color: INK4, marginBottom: 5 }}>{d.windowNote}</Text> : null}
        <View style={s.parcHead}>
          <Text style={[s.cN, s.hCell]}>#</Text>
          <Text style={[s.cMes, s.hCell]}>Periodo</Text>
          <Text style={[s.cMonto, s.hCell]}>Monto</Text>
          <Text style={[s.cEst, s.hCell]}>Estatus</Text>
        </View>
        {(d.rows || []).map((r, i) => (
          <View key={i} style={r.isCur ? s.parcRowCur : s.parcRow}>
            <Text style={s.cN}>{r.n}</Text>
            <View style={s.cMes}>
              <Text>{r.mes}{r.isCur ? '  (actual)' : ''}</Text>
              {/* El renglón se identifica por mes; el ordinal de la mensualidad
                  y el día exacto van debajo ("cuota 8/36 · vence 01 jul 2026"). */}
              {r.sub ? <Text style={s.cSub}>{r.sub}</Text> : null}
              {r.nota ? <Text style={s.cNota}>{r.nota}</Text> : null}
            </View>
            <Text style={[s.cMonto, { color: r.montoColor || INK }]}>{r.monto}</Text>
            <Text style={[s.cEst, { color: r.color }]}>{r.estatus}</Text>
          </View>
        ))}

        {/* Liquidación */}
        <View style={s.liquid}>
          <View>
            <Text style={s.liquidLbl}>Liquidación anticipada{d.liquid?.estimada ? ' (estimada)' : ''}</Text>
            <Text style={s.liquidDesc}>{d.liquid?.desc}</Text>
          </View>
          <Text style={s.liquidVal}>{d.liquid?.value}</Text>
        </View>

        <Text style={s.footer}>{d.footer}</Text>
      </Page>
    </Document>
  );
};

export default EstadoCuentaPDF;
